import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  height: ', ';\n  /* This transition height is borrowed from banner specifically to make the\n  shortening occur in line with banner\'s lengthening. */\n  transition: height 0.25s ease-in-out;\n  display: flex;\n  flex-direction: row;\n  position: fixed;\n  left: 0;\n  /* force this to have the width of the Spacer above */\n  width: inherit;\n  z-index: ', ';\n'], ['\n  height: ', ';\n  /* This transition height is borrowed from banner specifically to make the\n  shortening occur in line with banner\'s lengthening. */\n  transition: height 0.25s ease-in-out;\n  display: flex;\n  flex-direction: row;\n  position: fixed;\n  left: 0;\n  /* force this to have the width of the Spacer above */\n  width: inherit;\n  z-index: ', ';\n']);

import styled from 'styled-components';
import { zIndex } from '../../shared-variables';

var NavigationFixedContainer = styled.div(_templateObject, function (_ref) {
  var topOffset = _ref.topOffset;
  return topOffset ? 'calc(100vh - ' + topOffset + 'px)' : '100vh';
}, zIndex.base);

NavigationFixedContainer.displayName = 'NavigationFixedContainer';
export default NavigationFixedContainer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/styled/NavigationFixedContainer.js
// module id = 611
// module chunks = 0